import React from 'react'

import Header from '../Header/Header'
import GridMenu from './GridMenu/GridMenu'

import { GlobalStyle } from '../PrintView/style'
import Settings from 'settings'
import { ActionLink } from '../../containers/AdminPanel/MenuSettings'
import { ButtonDiv } from '../../containers/AdminPanel/WinrestForm'
import { getLanguage } from '../../utils/Locale'

const weekView = props => {
    const {
        title,
        days = [],
        isReady,
        concept,
        orientation,
        items = [],
        language = '',
        useCommercialName,
        hideLabels,
        hideIntolerences,
        hideMenuPrice,
        hideRecipePoints,
        hideEnergyKcal,
        showEnergyKcalByPortion,
        dataSource,
        zoom,
        print,
    } = props
    if (!isReady) {
        return <p>Waiting...</p>
    }

    const lang = getLanguage(language)

    const _getWeekDateString = days => {
        const firstDay = days.length && days[0].date
        const lastDay = days.length && days[days.length - 1].date
        const sameMonth = firstDay.month() === lastDay.month()
        return sameMonth
            ? `${firstDay.locale(lang).format('D')} ${
                  Settings.translations[lang].to_week
              } ${lastDay.locale(lang).format('D MMMM')}`
            : `${firstDay.locale(lang).format('D MMMM')} ${
                  Settings.translations[lang].to_week
              } ${lastDay.locale(lang).format('D MMMM')}`
    }

    const headerTitle = title || Settings.translations[lang].this_week
    const headerSubtitle = `${
        Settings.translations[lang].week_from
    } ${_getWeekDateString(days)}`
    return (
        <div>
            <Header
                title={headerTitle}
                date={headerSubtitle}
                concept={concept}
                zoom={zoom}
                mode="week"
            />
            <GridMenu
                concept={concept}
                days={days}
                items={items}
                useCommercialName={useCommercialName}
                hideLabels={hideLabels}
                hideIntolerences={hideIntolerences}
                hideMenuPrice={hideMenuPrice}
                hideRecipePoints={hideRecipePoints}
                hideEnergyKcal={hideEnergyKcal}
                showEnergyKcalByPortion={showEnergyKcalByPortion}
                dataSource={dataSource}
                zoom={zoom}
                language={language}
            />
            {print && (
                <ActionLink
                    style={{
                        margin: 0,
                        position: 'absolute',
                        bottom: '0',
                        top: '0',
                        right: '0',
                    }}
                >
                    <ButtonDiv
                        style={{
                            fontSize: '1.5em',
                            backgroundColor: '#f28d1b',
                        }}
                        onClick={() => window.print()}
                    >
                        PRINT
                    </ButtonDiv>
                </ActionLink>
            )}
            <GlobalStyle zoom={zoom} />
        </div>
    )
}

export default weekView
